import { Box, Typography } from '@mui/material';
import { conversationTagsSx } from 'modules/conversations/styles';
import { TableV3TruncatedChipList } from 'common/table/components/TableV3TruncatedChipList';
import { isTagSelected } from 'modules/conversations/utils/isTagSelected';

// Roughly two rows at the column's 240px min width. Capping by count rather
// than by measured rows gives a ragged edge, but needs no layout reads.
const MAX_VISIBLE_TAGS = 4;
const DESIGN_TAG_GAPS = { columnGap: '12px', rowGap: '10px' };

type Props = {
  tags: string[];
  // Given by the tables, so a pill filters by the tag it shows. Optional so a
  // caller with nothing to filter renders the same pills, inert.
  onTagClick?: (tag: string) => void;
  // The tags currently filtering the table, so a pill shows whether it is one.
  selectedTags?: string[];
};

export const ConversationTagsCell: React.FC<Props> = ({
  tags,
  onTagClick,
  selectedTags
}) => {
  if (!tags.length) {
    return <Typography>-</Typography>;
  }

  return (
    <Box sx={conversationTagsSx.tagsCell}>
      <TableV3TruncatedChipList
        items={tags}
        maxItems={MAX_VISIBLE_TAGS}
        onChipClick={onTagClick}
        isSelected={(tag) => isTagSelected(selectedTags ?? [], tag)}
        gaps={DESIGN_TAG_GAPS}
      />
    </Box>
  );
};
